import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { activityApi } from '@/api/endpoints';

/**
 * Đợi bao lâu mới ghi lại CÙNG một màn hình. Đi qua đi lại giữa hai mục trong lúc làm một việc
 * không phải là «dùng mục đó hai lần»; con số này cũng chặn luôn lượt ghi kép của React ở chế độ
 * phát triển.
 */
const REPEAT_AFTER_MS = 60_000;

/**
 * BÁO MÀN HÌNH VỪA MỞ cho máy chủ (25/09/2026) — nguồn của mục «Lịch sử truy cập».
 *
 * Trình duyệt chỉ gửi đường dẫn; máy chủ mới là nơi quyết định đường dẫn ấy thuộc màn hình nào
 * (`SCREENS`), nên không ai tự bịa ra được tên mục. Gọi rồi quên: lỗi mạng không bao giờ làm phiền
 * người đang làm việc.
 */
export function useScreenTracking(enabled: boolean): void {
  const { pathname } = useLocation();
  const sent = useRef(new Map<string, number>());

  useEffect(() => {
    if (!enabled) return;
    const now = Date.now();
    const last = sent.current.get(pathname);
    if (last !== undefined && now - last < REPEAT_AFTER_MS) return;
    sent.current.set(pathname, now);
    void activityApi.trackScreen(pathname);
  }, [enabled, pathname]);
}
